import { render } from "./AccountPasswordPage.vue?vue&type=template&id=0349b4f1&ts=true"
import script from "./AccountPasswordPage.vue?vue&type=script&lang=ts"
export * from "./AccountPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__